import React, {SVGAttributes} from 'react';
export function ArrowLeft(props: SVGAttributes<SVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 25 25"
            fill="none"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.6659 20.9098L6.25586 12.4998L14.6659 4.08984L16.0759 5.49984L9.07586 12.4998L16.0759 19.4998L14.6659 20.9098Z"
                fill={props.fill}
            />
        </svg>
    );
}

